import { t as e } from "./constants-DOpa8YMW.js";
//#region src/components/Map/Root/Popup/utils/moveIntoView/index.ts
function t(t, n, r, i, a, o) {
	let s = {
		left: a.left || e.left,
		right: a.right || e.right,
		top: a.top || e.top,
		bottom: a.bottom || e.bottom
	}, c = i.top || 0, l = i.left || 0, u = {
		top: t.top - c,
		bottom: t.bottom - c,
		left: t.left - l,
		right: t.right - l,
		width: t.width,
		height: t.height
	}, d = {
		top: u.top >= s.top,
		left: u.left >= s.left,
		bottom: u.bottom <= i.height - s.bottom,
		right: u.right <= i.width - s.right
	};
	if (Object.values(d).includes(!1)) {
		let e = 0, t = 0;
		d.top ? d.bottom || (e = i.height - s.bottom - u.bottom) : e = s.top - u.top, d.left ? d.right || (t = i.width - s.right - u.right) : t = s.left - u.left, o({
			longitude: n.longitude - t / i.width * (r.right - r.left),
			latitude: n.latitude + e / i.height * (r.top - r.bottom)
		});
	}
}
//#endregion
//#region src/components/Map/Root/Popup/styles.ts
var n = "\n  bg-base-white border border-primary-100 w-auto overflow-hidden\n  rounded-lg shadow-sm\n";
//#endregion
export { t as n, n as t };
